import { Accordion } from '@hc-frontend/core-ui';
import { isDefined } from '@hc-frontend/core-utils-validations';

import { formatAddress } from '../../helpers/format-address';
import { formatDependent } from '../../helpers/format-dependent';
import { formatHouseholdSize } from '../../helpers/format-household';
import { formatIncome } from '../../helpers/format-income';
import { formatMember } from '../../helpers/format-member';
import { UserLeadItem } from '../../molecules/user-lead-item/user-lead-item';
import type { UserLeadAccordionProps } from './user-lead-accordion.types';

export function UserLeadAccordion({ lead }: UserLeadAccordionProps) {
  const { applicant, spouse, children } = lead;

  return (
    <Accordion
      id="user-lead-accordion"
      triggerClassName="py-12-12 px-24-24 border-b border-gray-50"
      triggerIconClassName="right-24-24"
      title={
        <p className="hc-typography--heading-four font-semibold">
          User Profile
        </p>
      }
    >
      <div className="mb-16-16 flex flex-col gap-8-8 p-24-24 shadow-sm">
        <UserLeadItem
          title={`Name${isDefined(applicant?.dateOfBirth) ? ', Age' : ''}`}
          content={formatMember(applicant)}
          id="name-age"
        />

        {spouse ? (
          <UserLeadItem
            title="Spouse"
            content={formatDependent(spouse)}
            id="spouse"
          />
        ) : null}

        {children?.map((child) => (
          <UserLeadItem
            key={`${child.firstName}-${child.lastName}`}
            title="Child"
            content={formatDependent(child)}
            id="child"
          />
        ))}

        <hr className="my-8-8 border-gray-50" />

        <UserLeadItem
          title="Home Location"
          content={formatAddress(lead.location)}
          id="home-location"
        />

        <UserLeadItem
          title="Household Income"
          content={formatIncome(lead.householdIncome)}
          id="household-income"
        />

        <UserLeadItem
          title="Household Size"
          content={formatHouseholdSize(lead.householdSize)}
          id="household-size"
        />
      </div>
    </Accordion>
  );
}
